export const months = {
  January: "January",
  February: "February",
  March: "March",
  April: "April",
  May: "May",
  June: "June",
  July: "July",
  August: "August",
  September: "September",
  October: "October",
  November: "November",
  December: "December",
}

const generateDayOptions = ()=> {
  const dayNumbers = {}
  for (let i = 1; i <= 31; i++) {
    dayNumbers[i] = i.toString();
  }
  return dayNumbers;
}

export const days = generateDayOptions();


const generateYearOptions = () => {
  const yearNumbers = {}
  const startYear = 1900;
  const endYear = new Date().getFullYear();

  for (let i = startYear; i <= endYear; i++) {
    yearNumbers[i] = i.toString();
  }

  let newArr = []

  Object.keys( yearNumbers )
  .sort()
  .reverse()
  .forEach((key) => {
    newArr.push(key);
  })
  return newArr;
};

export const years = generateYearOptions();